/**
 * @generated SignedSource<<2db46dc4a886e041583754e0eaf6c0fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineStoreCustomizeSectionsSection_task$data = {
  readonly canBeDisabled: boolean;
  readonly task: {
    readonly title: string;
  } | null;
  readonly " $fragmentType": "RoutineStoreCustomizeSectionsSection_task";
};
export type RoutineStoreCustomizeSectionsSection_task$key = {
  readonly " $data"?: RoutineStoreCustomizeSectionsSection_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineStoreCustomizeSectionsSection_task">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineStoreCustomizeSectionsSection_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeDisabled",
      "storageKey": null
    }
  ],
  "type": "RoutineTaskListSectionTask",
  "abstractKey": null
};

(node as any).hash = "0cc53404a7a06375c9bf5a1ad9314afd";

export default node;
